/* Variant of the table for large screens, where everything is expanded horizontally */
import { Stack, Text, Grid, Group, Space } from "@mantine/core";
import { IconCurrencyEthereum } from "@tabler/icons";
import EthAddress from "../EthAddress/EthAddress";;

export default function DelegatorTable(props) {
  return (
    <Stack spacing={24} sx={{ width: "100%" }}>
      <Text size="xl" fw={700}>
        Pool Delegators
      </Text>
      <Stack spacing={24}>
        <Grid
          columns={24}
          sx={{
            borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
            borderRadius: "7px",
          }}
        >
          <Grid.Col span={12}>
            <Text>Address</Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <Text>Stake</Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <Text>Share</Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <Text>Fees Earned</Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <Text>LPT Earned</Text>
          </Grid.Col>
        </Grid>
      </Stack>
      {props.sortedDelegators.map(function (thisTrancoder, idx) {
        return (
          <Stack
            spacing={24}
            sx={{
              borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
              borderRadius: "7px",
            }}
            key={"transcoder-" + idx}
          >
            <Grid columns={24} sx={{ marginBottom: "12px" }}>
              <Grid.Col span={12}>
                <EthAddress
                  address={thisTrancoder.ID}
                  cachedENS={props.cachedENS}
                />
              </Grid.Col>
              <Grid.Col span={3}>
                <Text>{thisTrancoder.bondedAmount.toFixed(2)} LPT</Text>
              </Grid.Col>
              <Grid.Col span={3}>
                <Text>
                  {((thisTrancoder.bondedAmount / props.totalStake) * 100).toFixed(2)}{" "}
                  %
                </Text>
              </Grid.Col>
              <Grid.Col span={3}>
                <Group>
                  <Text>
                    {parseFloat(
                      thisTrancoder.fees + thisTrancoder.withdrawnFees
                    ).toFixed(4)}
                  </Text>
                  <IconCurrencyEthereum size={18} color={"#86c232"} />
                </Group>
              </Grid.Col>
              <Grid.Col span={3}>
                <Text>
                  {(
                    thisTrancoder.bondedAmount +
                    thisTrancoder.unbonded -
                    Math.abs(thisTrancoder.principal)
                  ).toFixed(2)}{" "}
                  LPT
                </Text>
              </Grid.Col>
            </Grid>
          </Stack>
        );
      })}
    </Stack>
  );
}
